// VH-229 refinement: number and date formatting of the weekly plan (locale thousands separators).

export const planLocale = (lang) => (lang?.startsWith('de') ? 'de-CH' : lang || 'en')

export const fmt = (value, lang, digits = 0) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? '—'
    : new Intl.NumberFormat(planLocale(lang), { maximumFractionDigits: digits, minimumFractionDigits: 0 })
      .format(Number(value)).replace(lang?.startsWith('de') ? '.' : /$^/, ',')

/** "Samstag, 19. Sept." — weekday names come from Intl, never from a hardcoded list. */
export const fmtWeekday = (isoDate, lang) =>
  isoDate
    ? new Intl.DateTimeFormat(planLocale(lang), { weekday: 'long', day: 'numeric', month: 'short' })
      .format(new Date(`${isoDate}T12:00:00`))
    : ''

/** "21.–25. Sept." — the container days of a week (Monday + count - 1), formatted by Intl. */
export const fmtDayRange = (weekStart, count, lang) => {
  if (!weekStart || !count) return ''
  const start = new Date(`${weekStart}T12:00:00`)
  const end = new Date(start)
  end.setDate(start.getDate() + count - 1)
  const f = new Intl.DateTimeFormat(planLocale(lang), { day: 'numeric', month: 'short' })
  return f.formatRange ? f.formatRange(start, end) : `${f.format(start)} – ${f.format(end)}`
}
